import { Navigate, Outlet } from 'react-router-dom';
import { getSession } from '@/domains/auth/services/auth.service';

/**
 * PublicRoute - Protection pour les pages publiques (auth)
 * 
 * Si l'utilisateur est connecté → redirige vers son dashboard
 * Si l'utilisateur n'est PAS connecté → affiche la page
 */
export default function PublicRoute() {
  const session = getSession();

  // Connecté → redirection vers dashboard
  if (session) {
    return <Navigate to={session.dashboardPath} replace />;
  }

  // Non connecté → affiche la page
  return <Outlet />;
}
